import request from "@/uilt/new-axios.js";
import serverConfig from "@/assets/global/serverConfig";

const prefix = `/${serverConfig.msCustomerService}/contract-operation`;

/** 保存合同终止/作废申请 */
export const saveContractOperation = (data) => {
  return request.postJson(`${prefix}/save`, data);
};

/** 更新合同终止/作废申请 */
export const updateContractOperation = (data) => {
  return request.postJson(`${prefix}/update`, data);
};

/** 获取合同终止/作废申请列表 */
export const getContractOperationList = (data) => {
  return request.postJson(`${prefix}/get-contract-operation-list`, data);
};

/** 获取合同终止/作废申请详情 */
export const getContractOperationDetail = (guid) => {
  return request.get(`${prefix}/detail?guid=${guid}`);
};

/** 删除合同终止/作废申请 */
export const deleteContractOperation = (data) => {
  return request.postJson(`${prefix}/delete`, data);
};

